import { CatalogItemListRequest } from '@common/model/catalog/item/list.request';
import { CatalogItemType } from '@common/model/catalog/item/type';
import { ClientWebPage } from '@common/model/meta/clientWebPage';
import { ClientWebPageProps } from '@common/model/meta/clientWebPageProps';
import { ApiServerEntityIDType } from '@cp/utils/apiServer/types';
import { DEFAULT_SUBCATALOG_PER_PAGE } from '@common/const/catalog';

export const getIsSubcatalog = (pageProps: ClientWebPageProps[ClientWebPage.Catalog]) => {
  return Boolean(pageProps.filter);
};

export const buildSubcatalogListRequest = ({
  pageProps,
  cityId,
}: {
  pageProps: ClientWebPageProps[ClientWebPage.Catalog];
  cityId: ApiServerEntityIDType;
}): CatalogItemListRequest => {
  return {
    type: pageProps.catalogType,
    careerId: pageProps.careerId,
    cityId,
    filter: pageProps.filter,
    page: 1,
    pagination: DEFAULT_SUBCATALOG_PER_PAGE,
  };
};

export const buildSubcatalogInversedListRequest = ({
  pageProps,
  cityId,
}: {
  pageProps: ClientWebPageProps[ClientWebPage.Catalog];
  cityId: ApiServerEntityIDType;
}): CatalogItemListRequest => {
  return {
    type: pageProps.catalogType === CatalogItemType.Resume ? CatalogItemType.Vacancy : CatalogItemType.Resume,
    careerId: pageProps.careerId,
    cityId,
    // filter,
    page: 1,
    pagination: 5,
  };
};
